type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const isDev = import.meta.env.DEV;

function write(level: LogLevel, message: string, data?: unknown): void {
  if (!isDev && level !== 'warn' && level !== 'error') return;
  const line = `[${level.toUpperCase()}] ${message}`;
  if (data === undefined) {
    console[level === 'error' ? 'error' : level === 'warn' ? 'warn' : 'log'](line);
    return;
  }
  console[level === 'error' ? 'error' : level === 'warn' ? 'warn' : 'log'](line, data);
}

export const logger = {
  debug: (message: string, data?: unknown) => write('debug', message, data),
  info: (message: string, data?: unknown) => write('info', message, data),
  warn: (message: string, data?: unknown) => write('warn', message, data),
  error: (message: string, data?: unknown) => write('error', message, data),
};
